import { Navigate, Route, Routes } from 'react-router-dom';

import { JobReportPreview, PublicJobReport } from '@/pages';


const App = () => {
  return (
    <Routes>
      <Route path="/job/:customerId/preview" element={ <JobReportPreview/> }/>
      <Route path="/public/:publicLinkId" element={ <PublicJobReport/> }/>
      <Route path="*" element={ <Navigate to="/404.html"/> }/>
    </Routes>
  );
};


export default App;